module.exports = __webpack_public_path__ + "img/call-inject.3c04ce51.svg";